import "./sensorLogsCompStyle.css";

function SensorLogsBox() {
    return(
        <article className='flex-nogap column flex-nowrap align-items-cntr border rounded color-foreground bg-color-background min-width-250px max-width-250px min-height-lg max-height-lg'>
            <section className='flex justify-content-cntr align-items-cntr border-bottom font-sm align-txt-cntr width-250px'>
                <h5 className='padding-t-sm padding-b-sm'>Sensor Logs:</h5>
            </section>
            <ul id="sensorlogsbox"className="flex-nogap column flex-nowrap justify-content-start align-items-cntr overflow-scroll overflow-x-hidden list-style-none font-md color-foreground min-width-250px max-width-250px max-height-xl"></ul>
        </article>
    );
}

export default SensorLogsBox;